import RpcClass from "@/server/RpcClass";
import {WsPipe} from "@/utils/WsPipe";
const parseCookie = str =>
    str
        .split(';')
        .map(v => v.split('=', 2))
        .reduce((acc, v) => {
            if(v && v.length == 2) {
                acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
            }
            return acc;
        }, {});

export default function fixCookies(){
    if(!window["isCordova"]){
        return;
    }
    let cookie = cordova.plugin.http.getCookieString(RpcClass.baseAddress);
    // console.log(cookie);
    if(cookie){
        let cookieValues = parseCookie(cookie);
        // console.log(cookieValues['sess']);
        if(cookieValues['sess']){
            RpcClass.sessionCookie = cookieValues['sess'];
            WsPipe.SESSION_ID = RpcClass.sessionCookie;
        }
    }
}

export function getUrlCookieSuffix(){
    return "internal-x-sess=" + encodeURIComponent(RpcClass.sessionCookie);
}